import React from "react";
import style from "./index.module.scss";
import {
    currentStuInfoAtom,
    currentStuNoAtom,
    showModalAtom,
    useAddTag,
    useClearModalState,
    useRemoveTag,
    useShuffle
} from "../../../../../service/stores/RollCallStore";
import { Button, Modal } from "antd";
import InputTag from "../InputTag";
import CustomTag from "../CustomTag";
import { useAtomValue } from "jotai";
import classNames from "classnames";

interface RollModalProps {
    onhandleClick: () => void;
}

export default function RollModal({ onhandleClick }: RollModalProps) {
    const visible = useAtomValue(showModalAtom);
    const currentStuNo = useAtomValue(currentStuNoAtom);
    const stuInfo = useAtomValue(currentStuInfoAtom);

    const addTag = useAddTag();
    const removeTag = useRemoveTag();
    const shuffle = useShuffle();
    const clearModal = useClearModalState();

    function handleClick() {
        shuffle.start();
        onhandleClick();
    }

    return (
        <Modal
            className={style.root}
            visible={visible}
            footer={null}
            onCancel={clearModal}>
            <h1 className={style.title}>随机选人</h1>
            <p className={style.tip}>
                随机选取学生参与作答、表演、对话等课堂现场活动， <br />
                并根据现场表现给学生添加标签语
            </p>

            <div className={style.main}>
                <h1 className={style.name}>{stuInfo?.name || "姓名"}</h1>
                <div className={style.stuNo}>
                    {stuInfo?.studentNo || "学号"}
                </div>
            </div>

            <div
                className={classNames(style.tags, {
                    [style.tagsHidden]: shuffle.shuffling || !currentStuNo
                })}>
                {stuInfo?.markList.map(item => (
                    <CustomTag
                        key={item.id}
                        visible
                        onClose={() => removeTag(item.id)}>
                        {item.mark}
                    </CustomTag>
                ))}
                <InputTag onSubmit={text => addTag(currentStuNo, text)} />
            </div>

            <div className={style.footer}>
                <Button
                    type="primary"
                    className={style.button}
                    onClick={handleClick}
                    disabled={shuffle.shuffling}>
                    {currentStuNo === "" ? "开始选人" : "继续选人"}
                </Button>
            </div>
        </Modal>
    );
}
